import React from 'react'

import { GraphLineType } from '@src/Application/Types/ComponentTypes'

import { Graph } from './Graph'
import { Desktop, Mobile } from './LineGraph.styled'
import { getMobileData } from './utils'

export const LineGraph = (props: GraphLineType): JSX.Element => {
    const { graphData } = props

    const mobileData = getMobileData(graphData)

    return (
        <>
            <Desktop>
                <Graph {...props} height={550} graphData={graphData} />
            </Desktop>
            <Mobile>
                <Graph {...props} height={250} graphData={mobileData} />
            </Mobile>
        </>
    )
}
